import { Badge } from "@/components/ui/badge";

import {
  jobUrgencyToBgClasses,
  jobUrgencyToIcon,
  jobUrgencyToLabel,
} from "@/lib/constants";
import { cn } from "@/lib/utils";
import { JobUrgency } from "@/types";

export const TableJobUrgencyBadge = ({
  className,
  urgency,
}: {
  className?: string;
  urgency: JobUrgency;
}) => {
  const Icon = jobUrgencyToIcon[urgency];

  return (
    <Badge
      variant="secondary"
      className={cn(
        "items-center gap-2",
        jobUrgencyToBgClasses[urgency],
        className,
      )}
    >
      <Icon className="h-3.5 w-3.5 text-slate-600" />
      {jobUrgencyToLabel[urgency]}
    </Badge>
  );
};
